module.exports = __webpack_public_path__ + "img/CreditProplat.e5a18a87.png";